import React from 'react';
import { Provider } from 'react-redux'
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import store from './redux';

import * as ROUTES from 'config/constants/routes';

import Root from 'containers/Root';

import Chat from 'containers/Chat';
import Configuration from 'containers/Configuration';
import Login from 'containers/Login';
import SignUp from 'containers/SignUp';
import NotFound from 'containers/NotFound';
import './App.css';

import Firebase, { FirebaseContext } from 'services/firebase';


class App extends React.Component {
  constructor(props) {
    super(props);
    this.firebase = new Firebase()
  }

  render() {
    return (
      <Provider store={store}>
        <FirebaseContext.Provider value={this.firebase}>
          <BrowserRouter>
            <Switch>
              <Route exact path={ROUTES.LOGIN} component={Login} />
              <Route exact path={ROUTES.SIGN_UP} component={SignUp} />

              <Root>
                <Route exact path={ROUTES.CHAT} component={Chat} />
                <Route exact path={ROUTES.CONFIGURATION} component={Configuration} />
              </Root>

              <Route path="*" component={NotFound} />
            </Switch>
          </BrowserRouter>
        </FirebaseContext.Provider>
      </Provider>
    );
  }
}

export default App;

